import {useSessionContext} from "../../reactContext/contextCustomHooks/useSessionContext"
import {useTranslation} from "react-i18next"
import {useNavigate} from "react-router-dom"
import useTeam from "../../swrCustomHooks/useTeam"
import LoadingComponent from "../../components/loading-component/LoadingComponent"

export default function HomeContent() {
    const {t} = useTranslation()
    const {sessionContext} = useSessionContext()
    const {team, isLoadingTeam, isErrorTeam} = useTeam(sessionContext.idTeam)
    let navigate = useNavigate()

    if (isErrorTeam || isLoadingTeam || team?.message) return <LoadingComponent/>
    return (
        <>
        <div className="SECTION HOME-CONTENT">
            <h2>{t("My projects")}</h2>
            <div className="home-sections-module">
                <div className={`st-section ${team.team.licence.includes("st") === false ? "disable" : ""}`} onClick={() => navigate("/st/projects")}>
                    <div className="st-section-header">
                        <p>{t("My subtitling projects")}</p>
                        <div className="grey-line-100"></div>
                    </div>
                    <div className="st-section-content">
                        <div className="circle">
                            <div className="circle-content">
                                <span>{team.team.nb_credits}</span>
                                <p>{t(team.team.nb_credits > 1 ? "credits" : "credit")}</p>
                            </div>
                        </div>
                    </div>
                    <div className="st-section-footer">
                        <div className="btn">
                            <p>{t("See all projects")}</p>
                        </div>
                    </div>
                </div>
                <div className={`ecp-section ${team.team.licence.includes("ecp") === false ? "disable" : ""}`} onClick={() => navigate("/ecp/projects")}>
                    <div className="ecp-section-header">
                        <p className="section-title">{t("My ECP projects")}</p>
                        <div className="grey-line-100"></div>
                    </div>
                    <div className="ecp-section-content">
                        <div className="circle">
                            <div className="circle-content">
                                <span>{team.team.nb_credits_ecp}</span>
                                <p>{t(team.team.nb_credits_ecp > 1 ? "credits" : "credit")}</p>
                            </div>
                        </div>
                    </div>
                    <div className="ecp-section-footer">
                        <div className="btn">
                            <p>{t("See all projects")}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </>
    )
}